import { Observable } from 'rxjs';
import { ItemForDisplay } from './item.model';
import { MenuItem } from 'primeng/api';

export interface AppBaseEntity {
  id: number | null;
  createDate: Date;
  updateDate: Date;
  deleteDate: Date;
}

export interface CountryState {
  id: number;
  abbreviation: string;
  name: string;
  isActive: boolean;
}

export interface BusinessSettings {
  name: string;
  websiteUrl: string;
  fromEmail: string;
  tz: string;
}

export const EMPTY_BUSINESS_SETTINGS: BusinessSettings = {
  name: '',
  websiteUrl: '',
  fromEmail: '',
  tz: 'America/New_York',
}

export interface AppUploadEvent {
  originalEvent: any;
  files: File[];
}

export type ProductsVM = {
  data: Observable<ItemForDisplay[]>;
  dataCount: Observable<number>;
  rows: Observable<number>;
  first: Observable<number>;
  sortBy: Observable<number>;
}

export interface MenuCommandEvent {
  item: MenuItem;
  orginalEvent: MouseEvent;
}

export interface PrimeNgDate {
  day: number;
  month: number;
  year: number;
  today: boolean;
  selectable: boolean;
  otherMonth?: boolean;
}
